import { useState, useEffect } from "react"
import { DateTime } from "luxon"

//Styles
import myStyles from "../../../../../styles/referrals/ReferralEntityFormChangeLog.module.css"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"

export default function ReferralEntityFormChangeLogFilter({
  activeFilters,
  setActiveFilters,
  users,
  organizations,
  fields,
}) {
  const [currentFilters, setCurrentFilters] = useState({
    category: "",
    createdFrom: DateTime.now().plus({ months: -1 }).toJSDate(),
    createdTo: DateTime.now().toJSDate(),
  })

  const categories = [
    { label: "Profile", value: "Profile" },
    { label: "Location", value: "Location" },
    { label: "Location service category", value: "LocationServiceCategory" },
  ]

  useEffect(() => {
    if (!!activeFilters) {
      setCurrentFilters(activeFilters)
    }
  }, [activeFilters])

  return (
    <>
      <div className={myStyles.filterGridContainer}>
        <div className={myStyles.filterItemCategoryTitle}>Category:</div>
        <div className={myStyles.filterItemCategory}>
          <Dropdown
            value={currentFilters.category}
            placeholder="Select a category"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, category: e.value })
            }}
            options={categories}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterItemFieldTitle}>Field</div>
        <div className={myStyles.filterItemField}>
          <Dropdown
            filter
            value={currentFilters.field}
            placeholder="Select a field"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, field: e.value })
            }}
            optionLabel={"displayName"}
            options={fields}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterItemFromTitle}>Created on or after:</div>
        <div className={myStyles.filterItemFrom}>
          <Calendar
            value={currentFilters.createdFrom}
            placeholder="Select a date"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, createdFrom: e.value })
            }}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterItemToTitle}>Created before or on:</div>
        <div className={myStyles.filterItemTo}>
          <Calendar
            value={currentFilters.createdTo}
            placeholder="Select a date"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, createdTo: e.value })
            }}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterItemOrganizationTitle}>
          Organization:
        </div>
        <div className={myStyles.filterItemOrganization}>
          <Dropdown
            value={currentFilters.organizationId}
            placeholder="Select an organization"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, organizationId: e.value })
            }}
            optionLabel={"name"}
            optionValue={"id"}
            options={organizations}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterItemStaffTitle}>Staff:</div>
        <div className={myStyles.filterItemStaff}>
          {" "}
          <Dropdown
            value={currentFilters.userId}
            placeholder="Select a staff member"
            onChange={(e) => {
              setCurrentFilters({ ...currentFilters, userId: e.value })
            }}
            optionLabel={"fullName"}
            optionValue={"id"}
            options={users}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterGridItemButton}>
          <button
            type="button"
            className={`btn ${myStyles.filterButton} ${myStyles.filterButton2}`}
            onClick={() => {
              const newFilter = {
                category: "",
                createdFrom: DateTime.now().plus({ months: -1 }).toJSDate(),
                createdTo: DateTime.now().toJSDate(),
                includeFilterLists: true,
              }

              setCurrentFilters(newFilter)
              if (!!setActiveFilters) {
                setActiveFilters(newFilter)
              }
            }}
          >
            Clear
          </button>
          <button
            type="button"
            className={`btn ${myStyles.filterButton}`}
            onClick={() => {
              setActiveFilters({ ...currentFilters, includeFilterLists: false })
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </>
  )
}
